import React, {useEffect} from "react";
import { useNavigate } from 'react-router-dom';

function Error() {
    const navigate = useNavigate();

    useEffect(() => {
        alert("접근권한이 없습니다.");
        navigate("/adminLogin");
    },[]);

    return (
        <div>
            {/* 접근권한이 없습니다.  */}
        </div>
    )
}

export default Error;